import { matchPath } from 'react-router-dom';
import { APP_TOKEN } from './Constants';
import PublicRoutes from '../routes/public.routes';

const INVALID_STORED_TOKENS = new Set(['', 'null', 'undefined']);

export const getStoredAccessToken = (): string | null => {
	const token = localStorage.getItem(APP_TOKEN);
	if (!token) return null;
	const normalized = token.trim();
	return INVALID_STORED_TOKENS.has(normalized.toLowerCase()) ? null : normalized;
};

export const isPublicAppPath = (pathname: string): boolean =>
	PublicRoutes.some((route) =>
		Boolean(
			matchPath(pathname, {
				exact: route.exact,
				path: route.path,
			}),
		),
	);

export const shouldMountAuthenticatedGlobalHosts = (
	pathname: string,
	token: string | null = getStoredAccessToken(),
): boolean => Boolean(token) && !isPublicAppPath(pathname);
